<script lang="ts" setup>

const props = withDefaults(
  defineProps<{
    duration?: number
  }>(), {
    duration: 400
  })

function onBeforeEnter(el) {
  el.style.height = '0px'
}

function onEnter(el, done) {
  requestAnimationFrame(() => (el.style.height = `${el.scrollHeight}px`))
  setTimeout(done, props.duration)
}


function onLeave(el, done) {
  requestAnimationFrame(() => {
    el.style.height = `${el.scrollHeight}px`
    requestAnimationFrame(() => (el.style.height = '0px'))
  })
  setTimeout(done, props.duration)
}

</script>

<template>
  <Transition
    :css="false"
    name="height-transition"
    @enter="onEnter"
    @leave="onLeave"
    @before-enter="onBeforeEnter"
  >
    <slot />
  </Transition>
</template>
